import { render, staticRenderFns } from "./ListagemPedidos.vue?vue&type=template&id=5d25bc26"
import script from "./ListagemPedidos.vue?vue&type=script&lang=js"
export * from "./ListagemPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports